module.exports = __webpack_public_path__ + "static/media/feesbuzz_disable.d5f299e8.svg";